import React, { Component } from 'react'

import { assetUrl } from '../../../config';
import $ from 'jquery';
import { withT } from '../../../i18n';
class Eardley extends Component {
    server_path = window.src_path;
    constructor() {
        super()
    }

    loadInitJs() {
        /* var item_name = this.pr */
        /* console.log(item_name); */
    }
    componentDidMount() {
        this.loadInitJs();
    }
    render() {
        const { t } = this.props;
        return (
            <>
                <div className="portfolio__main">
                    <div className="wrapper">
                        <div className="portfolio__inner">
                            <div className="left__panel">
                                <div className="image_div">
                                    <a href=""><img src={assetUrl('home/Eardley.jpg')} alt="" /></a>
                                </div>
                            </div>
                            <div className="right__panel">
                                <h2 className="heading">Eardley</h2>

                                <h2 className="artist_name"><span>{t('work.by')} </span> Trevor Jones </h2>
                                <div className="desc">
                                    <p>Oil on canvas. 90 x 90 cm. (36 x 36 inches). 2012 (scannable QR code painting).</p>
                                </div>

                                <a href="https://opensea.io/assets/0xc4ea5b0abe37addf21809754feeabee5abbe9b15/27100160001" className="css_btn"><span>{t('work.viewArtwork')}</span></a>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default withT(Eardley);
